import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-block-time',
  templateUrl: './block-time.component.html',
  styleUrls: ['./block-time.component.scss']
})
export class BlockTimeComponent implements OnInit {

 
  showFilter: boolean = false;
  showRoomDetail: boolean = false;
  showAddBlock: boolean = false;
  
  constructor() { }


  ngOnInit(): void {
  }

  openFilter(){
    this.showFilter = true;
  }
  openRoomDetail(){
    this.showRoomDetail = true;
  }

  getCloseFilter(message) {
    this.showFilter = message;
  }
  getCloseRoomDetail(message) {
    this.showRoomDetail = message;
  } 

  openAddBlock(){
    this.showAddBlock = true;
  }
  
  getCloseAddBlock(message){
    this.showAddBlock = message;
  }


}
